import type { CrudArgs } from "./composables/ContextVoter";
import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class ExportVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationExportCreateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationExportCreate,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationExportReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationExportRead,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = () => false;

  public canDelete: ContextVoterInterface["canDelete"] = () => false;

  public canCrud: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationExportCreateany,
        PermissionAttributesEnum.GlobalOperationExportReadany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationExportCreate,
        PermissionAttributesEnum.ContextOperationExportRead,
      ],
    });
  };

  public canCreateTaskProductExport(item?: CrudArgs): boolean {
    const scope = item ?? {
      client: this.permissionService.defaultClient,
      location: this.permissionService.defaultLocation,
    };
    if (!this.canCreate(scope)) {
      return false;
    }
    return this._canCrud({
      item: scope,
      globalAttribute: PermissionAttributesEnum.GlobalOperationTaskproductReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationTaskproductRead,
      scopeLess: true,
    });
  }

  public canCreateTaskTimeEntryExport(item?: CrudArgs): boolean {
    const scope = item ?? {
      client: this.permissionService.defaultClient,
      location: this.permissionService.defaultLocation,
    };
    if (!this.canCreate(scope)) {
      return false;
    }
    return this._canCrud({
      item: scope,
      globalAttribute: PermissionAttributesEnum.GlobalOperationTasktimeentryReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationTasktimeentryRead,
      scopeLess: true,
    });
  }
}
